import moment from 'moment';
import EmployTypeService from "@/service/EmployTypeService";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffJobHistory } from "@/model/StaffJobHistory";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employeeJobHistoryValidationObj from "./S070200-EmployeeJobHistoryValidation.js";
import Settings from '../../../constants/Settings.js';
var employeeJobHistoryValidation = new employeeJobHistoryValidationObj();
export default {
  name: "employeeJobHistory",
  props: [
    "staffModel", "isJobHistoryViewMode"
  ],
  data: () => ({
    jobHistoryLocalization: t,
    jobHistoryDictEnum: dictEnum,
    staffJobHistory: new StaffJobHistory(),
    tempJobHistoryModel: new StaffJobHistory(),
    employTypeList: [],
    listKey: 1,
    IsLoaded: true,
    JobHistoryObj: {
      selectAll: false
    },
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  mounted() {
    employeeJobHistoryValidation.jobHistoryValidation();
    this.getAllEmployType();
  },
  methods: {
    async getAllEmployType() {
      const obj = {};
      const response = await EmployTypeService.getAllEmployTypes(obj);
      if (response.data.IsSuccess) {
        this.employTypeList = response.data.Data;
      } else {
        SweetAlertService.warning(response.data.Message);
      }
    },
    OnAddEmployeeJobHistoryButtonClick: function () {
      this.JobHistoryObj.selectAll = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          var self = this;
          var tempCode = 1;
          var seq = 1;
          self.staffModel.StaffJobHistoryList.forEach(element => {
            if (element.DateJoin != null && element.DateJoin != "") {
              element.DateJoin = moment(element.DateJoin).format(Settings.DateTime.yyyymmdd);
            }
            if (element.DateResign != null && element.DateResign != "") {
              element.DateResign = moment(element.DateResign).format(Settings.DateTime.yyyymmdd);
            }
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var staffJobHistory = new StaffJobHistory();
          staffJobHistory.StaffID = self.staffModel.StaffID;
          staffJobHistory.Seq = seq;
          staffJobHistory.tempCode = tempCode;
          staffJobHistory.IsEditMode = true;
          self.staffModel.StaffJobHistoryList.push(staffJobHistory);
        }
      });
    },
    OnEmployeeJobHistoryDeleteClick: function (data) {
      var self = this;
      self.staffModel.StaffJobHistoryList.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.staffModel.StaffJobHistoryList.splice(index, 1);
          return;
        }
      });
    },
    OnEmployeeJobHistorySelection: function (item) {
      var self = this;
      self.tempJobHistoryModel = item;
      if (this.isJobHistoryViewMode) {
        return;
      }
      if (item.IsEditMode) {
        return;
      }
      self.IsLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.staffModel.StaffJobHistoryList.forEach(element => {
            if (element.DateJoin != null && element.DateJoin != "") {
              element.DateJoin = moment(element.DateJoin).format(Settings.DateTime.yyyymmdd);
            }
            if (element.DateResign != null && element.DateResign != "") {
              element.DateResign = moment(element.DateResign).format(Settings.DateTime.yyyymmdd);
            }
            if (element.tempCode == item.tempCode) {
              self.IsLoaded = true;
              element.IsEditMode = true;
            } else {
              self.IsLoaded = true;
              element.IsEditMode = false;
            }
          });
          self.listKey += 1;
        }
        self.IsLoaded = true;
      });
    },
    changeEmployType: function (item) {
      var self = this;
      var employTypeDetail = self.employTypeList.find(
        obj => obj.EmpType == item.EmpType
      );
      item.EmployTypeDes = self.user.Lang == 'EN' ? employTypeDetail.EDesc : employTypeDetail.CDesc;
    },
    onJobHistoryFileChange(payload) {
      var self = this;
      const reader = new FileReader();
      var file = payload; // in case vuetify file input
      reader.onload = (function (f) {
        return function (e) {
          var path = reader.result ? reader.result.toString() : "";
          self.staffModel.StaffJobHistoryList.forEach(element => {
            if (element.tempCode == self.tempJobHistoryModel.tempCode) {
              element.JobHistoryURL = path;
              element.JobHistoryFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
              element.DocMime = file.type;
              element.IsImageFile = path.indexOf("image") != -1 ? true : false;
            }
          });
        };
      })(file);
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    OnJobHistoryImageOpen: function () {
      var self = this;
      $("#jobHistoryImage").click();
    },
    selectAllJobHistoryRecord: function () {
      var self = this;
      var IsSelected = self.JobHistoryObj.selectAll;
      self.staffModel.StaffJobHistoryList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    closeJobHistoryPopup: function () {
      var self = this;
      $('#deleteJobHistory').modal('hide');
    },
    deleteMultipleJobHistoryPopup: function () {
      var arrayList = [];
      var self = this;
      self.staffModel.StaffJobHistoryList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteJobHistory').modal('show');
      }
      else {
        SweetAlertService.warning(self.jobHistoryLocalization.t(self.jobHistoryDictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleJobHistory: function () {
      var self = this;
      var staffJobHistoryList = self.staffModel.StaffJobHistoryList.filter(
        obj => obj.isSelected !== true
      );
      self.staffModel.StaffJobHistoryList = staffJobHistoryList;
      self.JobHistoryObj.selectAll = false;
      $('#deleteJobHistory').modal('hide');
    },
    downloadJobHistoryFile: function (path) {
      var win = window.open();
      win.document.write('<iframe src="' + path + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    },
    changeJobFormDate: function (item) {
      var self = this;
      if (new Date(item.DateJoin) > new Date(item.DateResign)) {
        SweetAlertService.warning(self.jobHistoryLocalization.t(self.jobHistoryDictEnum.MSG_DateCompare));
        item.DateJoin = moment().format(Settings.DateTime.yyyymmdd);
        return;
      }
    },
    changeJobToDate: function (item) {
      var self = this;
      if (new Date(item.DateJoin) > new Date(item.DateResign)) {
        SweetAlertService.warning(self.jobHistoryLocalization.t(self.jobHistoryDictEnum.MSG_DateCompare));
        item.DateResign = moment().format(Settings.DateTime.yyyymmdd);
        return;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeJobHistory.js